module.exports = __webpack_public_path__ + "img/bullseye_arrow_icon.7a6caab3.svg";